import { JobBean }  from './job.bean';

export class GotoRoomJobBean extends JobBean{
    constructor (){
        super()
        this.param={itens:[]}
    }
    public associateJob(writData){       

    }
    public testJob(writTest,job,wrt){
              if (this._appData.room.id==job.nid || this._appData.room.id==job.param.room){
                if (job.param.space && this._appData.instagramUser.sp==job.param.space){
                  let text;
                  if (!wrt.jobs[writTest.id].completed){
                    text=wrt.jobs[writTest.id].onSuccess
                  }
                  wrt.jobs[writTest.id].completed=true;
                  let date=new Date();
                  wrt.jobs[writTest.id].dateEnd=date.getTime();   
                  this._companyService.getUserWrit(this._appData.instagramUser,writTest.group.toString()).set(wrt).then(val=>{              
                  })
                  return true;    
                }
              }
              else{
                return false;
              }

    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/quests/GotoRoomJob.ts